/** Compact credit figure: up to 4 dp, no trailing zeros (0.2500 -> "0.25"). */
const formatCredits = (n: number): string => Number(n.toFixed(4)).toString();

const isPrice = (n: number | undefined): n is number =>
  typeof n === 'number' && Number.isFinite(n);

/**
 * Per-image price line for a model's tooltip, or {@code null} when the catalog
 * couldn't price it (e.g. a stale pre-pricing cache entry). Always per image:
 * users can't pick a resolution, so megapixel pricing is converted upstream.
 */
export const formatCreditCost = (
  creditCost: number,
  referenceCreditCost?: number,
): string | null => {
  if (!isPrice(creditCost)) {
    return null;
  }
  const base = `≈ ${formatCredits(creditCost)} credits per image`;
  return isPrice(referenceCreditCost) && referenceCreditCost > 0
    ? `${base} + ${formatCredits(referenceCreditCost)} per reference image`
    : base;
};
